// Detecta que o SITE foi atualizado enquanto esta aba continua rodando o bundle
// antigo. Motivacao (09/09/2026): o dono abriu Produtos e viu "Ficha Tecnica em
// breve" horas depois do deploy que trocou essa tela — a aba fica aberta o dia
// inteiro e o SPA nunca recarrega sozinho. Mostrar a versao nova na barra
// lateral nao resolve: o numero vem do version.json, o codigo continua velho.
//
// Sinal usado: o hash do bundle. O index.html (no-cache) referencia
// /static/js/main.<hash>.js; se o hash servido agora e' diferente do script que
// esta rodando, houve deploy. Nao depende de versao embutida no build nem de
// relogio — funciona igual em build local, VPS e Electron (que carrega a URL).
import { useEffect, useRef, useState } from "react";

const INTERVALO_MS = 60 * 1000;
// Aba escondida por este tempo com atualizacao pendente recarrega sozinha ao
// voltar: quem ficou fora tanto tempo nao tem formulario pela metade.
const AUSENCIA_PARA_RECARREGAR_MS = 10 * 60 * 1000;

function hashDoScript(src) {
  const m = /\/static\/js\/main\.([a-z0-9]+)\.js/i.exec(src || "");
  return m ? m[1] : null;
}

function hashRodando() {
  const s = [...document.querySelectorAll("script[src]")].map((x) => hashDoScript(x.src)).find(Boolean);
  return s || null;
}

export async function hashServido() {
  const r = await fetch(`/?_v=${Date.now()}`, { cache: "no-store", headers: { Accept: "text/html" } });
  if (!r.ok) return null;
  return hashDoScript(await r.text());
}

async function versaoServida() {
  try {
    const r = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
    return r.ok ? (await r.json())?.current || null : null;
  } catch { return null; }
}

/** `{ disponivel, versao, atualizar }` — `atualizar()` recarrega a pagina. */
export default function useAtualizacaoDisponivel() {
  const [estado, setEstado] = useState({ disponivel: false, versao: null });
  const escondidaDesde = useRef(null);
  const pendente = useRef(false);

  useEffect(() => {
    const atual = hashRodando();
    if (!atual) return undefined; // dev server sem bundle hasheado
    let vivo = true;

    const checar = async () => {
      try {
        const novo = await hashServido();
        if (!vivo || !novo || novo === atual) return;
        pendente.current = true;
        setEstado({ disponivel: true, versao: await versaoServida() });
      } catch { /* sem rede: tenta no proximo ciclo */ }
    };
    const timer = setInterval(checar, INTERVALO_MS);

    const aoMudarVisibilidade = () => {
      if (document.hidden) { escondidaDesde.current = Date.now(); return; }
      const fora = escondidaDesde.current ? Date.now() - escondidaDesde.current : 0;
      escondidaDesde.current = null;
      if (pendente.current && fora >= AUSENCIA_PARA_RECARREGAR_MS) { window.location.reload(); return; }
      checar();
    };
    document.addEventListener("visibilitychange", aoMudarVisibilidade);
    return () => { vivo = false; clearInterval(timer); document.removeEventListener("visibilitychange", aoMudarVisibilidade); };
  }, []);

  return { ...estado, atualizar: () => window.location.reload() };
}
